import { AgencyHiringConstantMapping } from "./agencyHiringConstantMapping";

/**
 * Japan (JP) Agency Organization Name to Domain Name mappings, as they appear in ROMP
 */
export const AGENCY_HIRING_CONSTANT_MAPPING_JP: AgencyHiringConstantMapping = {
  // Add JP-specific agency mappings here
  // Example: "Japan Agency Name": "japan-agency-domain",
};
